import apisSettings from '@/apis/apisSettings'

/**
 * Lectura de la configuracion publica de la plataforma desde el front.
 *
 * Existe para que el precio no siga escrito a mano en cuatro vistas. Antes
 * estaba quemado en la portada, en el landing (dos veces) y en el backend, asi
 * que subirlo obligaba a acordarse de los cuatro sitios y bastaba olvidar uno
 * para anunciar un precio y cobrar otro.
 *
 * Solo llega lo que el backend marca como publico, asi que esto se puede usar
 * en pantallas sin sesion.
 */

/** Lo mismo que MONTH_PRICE_FALLBACK en PayController. */
export const PRECIO_MES_RESPALDO = 20000

export const CLAVE_PRECIO_MES = 'precio_mes_hospedaje'

// Una sola peticion por carga de la aplicacion, aunque tres vistas la pidan:
// se guarda la promesa y no el resultado, para que dos llamadas simultaneas no
// disparen dos peticiones.
let promesa = null

export function cargarPublicas() {
  if (!promesa) {
    // Sin catch aqui la promesa cacheada quedaria rechazada para siempre y
    // ninguna vista posterior volveria a intentarlo
    promesa = apisSettings.getPublic().catch(() => [])
  }
  return promesa
}

/** Para despues de que el administrador cambie un valor. */
export function olvidarPublicas() {
  promesa = null
}

/**
 * El precio del mes en pesos. Nunca lanza y nunca devuelve algo raro: si la
 * API no responde o el valor quedo ilegible, se devuelve el mismo respaldo que
 * usa el backend, para no anunciar un precio distinto al que se cobra.
 */
export async function precioMesHospedaje() {
  const filas = await cargarPublicas()
  const fila = (filas || []).find(f => f.key === CLAVE_PRECIO_MES)
  const numero = Number(fila && fila.value)

  return Number.isFinite(numero) && numero > 0 ? numero : PRECIO_MES_RESPALDO
}

/** 20000 -> "$20.000" */
export function enPesos(valor) {
  const numero = Number(valor)

  if (!Number.isFinite(numero)) {
    return ''
  }
  return `$${numero.toLocaleString('es-CO')}`
}
